/*
 * The marketing site's focus ring (audit 16): 2px of brand orange, 2px off
 * the element. The 2px between takes the colour the surface around it names
 * in --mk-ring-offset (RING_SURFACE, on the surface's own element; a custom
 * property inherits, Tailwind's ring variables do not): the surface's own
 * colour where orange reads at 3:1 against it (white 3.17, the canvas 3.04,
 * night 6.2), ink where it does not (sunken 2.91, orange-soft 2.87, the
 * light header's glass over the night and orange bands 2.3 and 2.7). That
 * makes a two-tone ring there: the ink 3:1 or more against the surface, the
 * orange 5.5:1 against the ink. Where no surface names one, the 2px is
 * mk-surface (white), Tailwind's own default.
 */

/** The ring, for a control whose surface names its offset. */
export const FOCUS_RING =
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mk-orange focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--mk-ring-offset,theme(colors.mk.surface))]';

const INK = '[--mk-ring-offset:theme(colors.mk.ink)]';

/** What each surface names as its rings' offset colour: a class for the surface's own element. */
export const RING_SURFACE = {
    surface: '[--mk-ring-offset:theme(colors.mk.surface)]',
    canvas: '[--mk-ring-offset:theme(colors.mk.canvas)]',
    sunken: INK,
    soft: INK,
    glass: INK,
    night: '[--mk-ring-offset:theme(colors.mk.night)]',
};

